import { render, staticRenderFns } from "./StarShopGet.vue?vue&type=template&id=79bd5500"
import script from "./StarShopGet.vue?vue&type=script&lang=js"
export * from "./StarShopGet.vue?vue&type=script&lang=js"
import style0 from "./StarShopGet.vue?vue&type=style&index=0&id=79bd5500&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports